<template>
  <div v-loading="loading" style="position:relative;">
    <div class="test_box" :class="{'test_box1':ShowTest}" v-if="btn_test">
      <el-button size="mini" type="primary" @click="ShowTest=!ShowTest">测 试</el-button>
      <div style="margin-top: 10px;" v-if="ShowTest">
        <el-date-picker
          size="mini"
          v-model="TestTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
        />
        <!-- <el-button size="mini" type="primary" style="margin-left: 10px;" @click="setTime">设置时间</el-button> -->
      </div>
    </div>
    <el-row class="checkinge-query">
      <div class="query">
        <label>{{ day }}</label>
        <el-date-picker v-model="params.AttendanceDate" type="date" value-format="yyyy/MM/dd" placeholder="请选择日期" @change="getWeek(true)" style="width:140px" :clearable="false" />
      </div>
      <div class="query">
        <label>节次</label>
        <el-select v-model="params.SectionNumber">
          <template v-for="i in 15">
            <el-option :key="i" :value="i" :label="'第'+i+'节课'"></el-option>
          </template>
        </el-select>
      </div>
      <div class="query">
        <label>年级</label>
        <el-select v-model="params.GradeId" @change="getClass" clearable>
          <template v-for="(i,index) in grades">
            <el-option :key="index" :value="i.GradeId" :label="i.Grade"></el-option>
          </template>
        </el-select>
      </div>
      <div class="query">
        <label>班级</label>
        <el-select v-model="params.ClassId" clearable>
          <template v-for="(i,index) in classes">
            <el-option :key="index" :value="i.ClassId" :label="i.ClassName"></el-option>
          </template>
        </el-select>
      </div>
      <div class="query">
        <label>姓名</label>
        <el-input type="text" v-model="params.FullName" placeholder="请填写姓名" clearable></el-input>
      </div>
      <div class="query">
        <el-button type="primary" @click="getData">查询/刷新</el-button>
        <el-button type="success" v-if="!isMB&&mainData.length" @click="onExport" plain :loading="bnLoading">导出</el-button>
      </div>
    </el-row>

    <div v-if="mainData.length">
      <div class="border" v-if="!isMB">
        <div class="table">
          <div v-for="item of mainData" :key="item.GradeId" class="table-item">
            <div class="table-high table-col">
              <span class="nobg" :class="{ 'checkNormal': item.Status==1, 'absent': item.Status==2 }">{{item.Grade}}{{item.Section.SectionName}}</span>
            </div>
            <div class="grade-box">
              <div class="table-gradeList table-col" v-for="cItem of item.Classes"
                :key="cItem.ClassId">
                <!-- 班级 -->
                <div class="table-gradeList_header">
                  <div class="table-gradeList_gradeNo nobg" :class="{ 'checkNormal': cItem.Status==1, 'absent': cItem.Status==2 }">
                    {{cItem.Class}}
                    <span v-if="cItem.checked">(已抽查)</span>
                  </div>
                </div>
                <!-- 学生列表 -->
                <div class="student-list m-scroll">
                  <div class="student-item" v-for="st of cItem.Students"
                    :key="st.StudentId">
                    <img :src="st.Face?face_purple:(st.AttendanceDtsId?face_blue:face)" v-if="st.atMode===0" class="face-icon">
                    <img :src="st.AttendanceDtsId?hand_blue:hand" v-else-if="st.atMode===1" class="hand-icon">
                    <span slot="reference" :class="{ 'normal': st.Status==1&&st.AttendanceDtsId==0&&!st.isChange, 'checkNormal': st.Status==1&&(st.AttendanceDtsId!=0||st.isChange),
                      'absent': st.Status == 2||st.noRecord, 'late': st.Status == 3, 'free': st.Status== 6, 'isChange': st.isChange, 'nobg': !st.isChange }"
                      v-if="st.Status!=4&&st.Status!=5&&!st.Face&&canWrite" @click="statusChange(st)">
                        {{ st.FullName }}
                      </span>
                    <span v-else :class="{ 'normal': st.Status==1&&st.AttendanceDtsId==0&&!st.isChange, 'checkNormal': st.Status==1&&(st.AttendanceDtsId!=0||st.isChange),
                      'absent': st.Status==2||st.noRecord, 'late': st.Status==3, 'leave': st.Status==4||st.Status==5, 'free': st.Status==6, 'face': st.Face, 'nobg': !st.isChange }">
                      {{ st.FullName }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="border" v-else>
        <el-collapse v-model="active" class="mb-collage">
          <el-collapse-item v-for="(item,index) in mainData" :key="item.GradeId" :title="item.Grade" :name="String(index+1)">
            <template slot="title">
              <span class="nobg" :class="{ 'checkNormal': item.Status==1, 'absent': item.Status==2 }">{{item.Grade}}({{item.Section.SectionName}})</span>
          </template>
            <div class="collage">
              <div class="collage-item nobg" v-for="clItem in item.Classes" :key="clItem.ClassId" @click="showStudents(clItem,item.Grade)"
               :class="{ 'checkNormal': clItem.Status==1, 'absent': clItem.Status==2 }"
              >
                {{clItem.Class}}
                <span v-if="clItem.checked">(已抽查)</span>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="footer">
        <div class="footer-tip">
          <template v-if="!isMB">
            <span class="statusText">图标对应状态：</span>
            <span class="statusText nobold">
              <img :src="hand" class="face-icon">纯手动未考勤
            </span>
            <span class="statusText nobold">
              <img :src="hand_blue" class="face-icon">纯手动已考勤
            </span>
            <span class="statusText nobold">
              <img :src="face" class="face-icon">刷脸+抽查未考勤
            </span>
            <span class="statusText nobold">
              <img :src="face_blue" class="face-icon">刷脸+抽查已抽查
            </span>
            <span class="statusText nobold">
              <img :src="face_purple" class="face-icon">刷脸+抽查已刷脸
            </span>
          </template>
          <el-popover
            v-else
            placement="top"
            width="155">
              <div><img :src="hand" class="face-icon">纯手动未考勤</div>
              <div style="margin: 5px 0;"><img :src="hand_blue" class="face-icon">纯手动已考勤</div>
              <div><img :src="face" class="face-icon">刷脸+抽查未考勤</div>
              <div style="margin: 5px 0;"><img :src="face_blue" class="face-icon">刷脸+抽查已抽查</div>
              <div><img :src="face_purple" class="face-icon">刷脸+抽查已刷脸</div>
            <span class="statusText nobold" slot="reference">查看图标</span>
          </el-popover>
        </div>
        <div style="display:inline-block;">
          <span class="statusText" v-if="!isMB">颜色对应状态：</span>
          <span class="statusText checkNormal nobg">正常</span>
          <span class="statusText absent nobg">异常</span>
          <span class="statusText late nobg">迟到</span>
          <span class="statusText leave nobg">请假或医疗</span>
          <!-- <span class="statusText checkNormal nobg">医疗</span> -->
          <span class="statusText free nobg">无故缺勤</span>
          <!-- <span class="statusText face nobg">已刷脸</span> -->
          <!-- <el-button type="primary" :disabled="loading" @click="beforeSave" size="small" v-if="canWrite">提 交</el-button> -->
          <template v-if="!isMB&&canWrite">
            <el-button type="primary" :disabled="loading" @click="save([1])" size="mini" v-if="hasGrade(1)">提交高一</el-button>
            <el-button type="primary" :disabled="loading" @click="save([2])" size="mini" v-if="hasGrade(2)">提交高二</el-button>
            <el-button type="primary" :disabled="loading" @click="save([3])" size="mini" v-if="hasGrade(3)">提交高三</el-button>
          </template>
        </div>
        <div v-if="isMB&&canWrite" class="bnBox">
          <el-button type="primary" :disabled="loading" @click="save([1])" size="mini" v-if="hasGrade(1)">提交高一</el-button>
          <el-button type="primary" :disabled="loading" @click="save([2])" size="mini" v-if="hasGrade(2)">提交高二</el-button>
          <el-button type="primary" :disabled="loading" @click="save([3])" size="mini" v-if="hasGrade(3)">提交高三</el-button>
        </div>
      </div>
      <div class="tb-box">
        <el-table :data="mainTable" border show-summary style="margin-top:10px;">
          <el-table-column prop="Grade" label="年级" fixed="left" />
          <el-table-column prop="Zc" label="正常" />
          <el-table-column prop="Wkq" label="未考勤" />
          <el-table-column prop="Yc" label="异常" />
          <el-table-column prop="Cd" label="迟到" />
          <el-table-column prop="Qj" label="请假" />
          <el-table-column prop="Yl" label="医疗" />
          <el-table-column prop="Wgqq" label="无故缺勤" />
          <el-table-column prop="Hj" label="合计" />
        </el-table>
      </div>
    </div>
    <div v-else class="border isNull">暂无留宿自习考勤数据</div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="94.5%">
      <div class="dialog-st">
      <div v-for="st in dialogData" :key="st.StudentId" class="dialog-st-item">
          <img :src="st.Face?face_purple:(st.AttendanceDtsId?face_blue:face)" v-if="st.atMode===0" class="face-icon">
          <img :src="st.AttendanceDtsId?hand_blue:hand" v-else-if="st.atMode===1" class="hand-icon">
          <span :class="{ 'normal': st.Status==1&&st.AttendanceDtsId==0&&!st.isChange, 'checkNormal': st.Status==1&&(st.AttendanceDtsId!=0||st.isChange),
            'absent': st.Status==2||st.noRecord, 'late': st.Status == 3, 'free': st.Status== 6, 'isChange': st.isChange, 'nobg': !st.isChange  }"
            v-if="st.Status!=4&&st.Status!=5&&!st.Face&&canWrite" @click="statusChange(st)">
              {{ st.FullName }}
            </span>
          <span v-else :class="{ 'normal': st.Status==1&&st.AttendanceDtsId==0&&!st.isChange, 'checkNormal': st.Status==1&&(st.AttendanceDtsId!=0||st.isChange),
            'absent': st.Status==2||st.noRecord, 'late': st.Status==3, 'leave': st.Status==4||st.Status==5, 'free': st.Status== 6, 'face': st.Face, 'nobg': !st.isChange }">
            {{ st.FullName }}
          </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="save([],dialogData)" :disabled="loading" size="small" type="primary">提 交</el-button>
        <el-button @click="dialogVisible = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- <grade-dialog ref="gradeDialog" @confirm="save"></grade-dialog> -->
  </div>
</template>

<script>
var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
// import gradeDialog from "./gradeDialog";
export default {
  components: {
    // gradeDialog
  },
  props: {
    isIndex: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      canWrite: this.$permission.canWrite("/attendance/selfstudyat"),
      api: require("@/api/at/attendance").default,
      grade_api: require("@/api/ed/grade").default,
      class_api: require("@/api/ed/class").default,
      sectionApi: require("@/api/ed/section").default,
      atApi: require("@/api/attendance/studystay").default,
      hand: require("@/assets/hand.png"),
      face: require("@/assets/face.png"),
      hand_blue: require("@/assets/hand_blue.png"),
      face_blue: require("@/assets/face_blue.png"),
      face_purple: require("@/assets/face_purple.png"),
      day: '',
      isMB: this.$store.state.isMB,
      mainData: [],
      pickData: [],
      send: [],
      subData: {},
      stData: [],
      loading: false,
      TermId: loginInfo.TermId,
      active: ["1","2","3"],
      dialogVisible: false,
      dialogTitle: "",
      dialogData: [],
      params: {
        AttendanceDate: this.$commonJs.getToday(),
        SectionNumber: null,
        GradeId: null,
        ClassId: null,
      },
      grades: [],
      classes: [],
      atSetting: [],
      mainTable: [],
      queried: {},
      TestTime: "",
      btn_test: false,
      ShowTest: false,
      bnLoading: false,
    }
  },
  beforeMount() {
    if (this.$route.query && this.$route.query.test == "1") {
      this.btn_test = true;
    } else {
      this.btn_test = false;
    }
    this.getWeek(this.params.AttendanceDate);
    this.getGrade();
      this.sectionApi.getNowNumber(this.TermId,1).then(res => {
        if(res.Code==0) {
          this.params.SectionNumber = res.Data||1;
        }
        if(!this.isIndex) this.getData();
      })
  },
  methods: {
    onPick(data) {
      this.getWeek(data)
    },
    getData() {
      this.subData = { Details: [], Remark: "" };
      this.mainData = [];
      this.send = [];
      this.pickData = [];
      this.stData = [];
      this.loading = true;
      this.queried = this.$commonJs.obj.removeNullKey(this.params);
      this.api.getStayStudents(this.queried).then(res => {
        this.loading = false;
        //------------------------------------------------------------
        // res.Data = [
        //   { Grade: "高一", GradeId: 1, Status: 1, 
        //     Classes: [
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, StudentId: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, StudentId: 2, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //     ],
        //     Stat: { Addr: 1, Cd: 2, Hj: 3, Qj: 4, Wgqq: 5, Yc: 6, Yl: 7, Zc: 8 },
        //     Section: { FaceStartTime: "2022-07-01 12:12:12", SectionName: "节次名" }
        //   },
        //   { Grade: "高二", GradeId: 2, Status: 1, 
        //     Classes: [
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 2, StudentId: 3, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 2, StudentId: 4, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 1, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //     ],
        //     Stat: { Addr: 9, Cd: 10, Hj: 11, Qj: 12, Wgqq: 13, Yc: 14, Yl: 15, Zc: 16 },
        //     Section: { FaceStartTime: "2022-07-01 12:12:12", }
        //   },
        //   { Grade: "高三", GradeId: 3, Status: 1, 
        //     Classes: [
        //       { Class: "1班", Status: 2, Students: [
        //         { AttendanceDtsId: 0, GradeSn: 3, StudentId: 5, FullName: "张三", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //         { AttendanceDtsId: 0, GradeSn: 3, StudentId: 6, FullName: "张四", Status: 1, Face: false, IsMedical: false, IsLeave: false },
        //       ]},
        //     ],
        //     Stat: { Addr: 17, Cd: 18, Hj: 19, Qj: 20, Wgqq: 21, Yc: 22, Yl: 23, Zc: 24 },
        //     Section: { FaceStartTime: "2022-07-01 12:12:12", }
        //   }
        // ]
        //------------------------------------------------------------
        if(res.Code==0) {
          if(res.Data.length==0) {
            // this.$message.warning("当前日期暂无留宿自习考勤数据")
            return;
          }
          this.atApi.getListByDate(this.params.AttendanceDate).then(atRes => {
            if(atRes.Code==0) {
              //----------------------------------
              // atRes.Data = [{ StayAtMode:1},{StayAtMode:1},{StayAtMode:1}]
              //----------------------------------
              var atSetting = atRes.Data||[];
              this.atSetting = atSetting;
              res.Data.forEach(e => {
                var isTime = false;
                var nowTime = (new Date()).getTime();
                var section = e.Section;
                var start = new Date(this.params.AttendanceDate + " " + section.FaceStartTime);
                if(start.getTime() <= nowTime) {
                  isTime = true;
                }
                e.Classes.forEach(n => {
                  n.checked = false;
                  n.Students.forEach(p => {
                    if(p.AttendanceDtsId && !p.Face && !p.IsLeave && !p.IsMedical) {
                      n.checked = true;
                    }
                    p.show = false;
                    p.atMode = atSetting[p.GradeSn-1].StayAtMode;
                    if(p.atMode==0) {
                      if(isTime && p.AttendanceDtsId==0 && p.Status!=4 && p.Status!=5 && !p.Face) {
                        p.noRecord = true;
                      }
                    } else if(p.atMode == 1) {
                      if((p.AttendanceDtsId==0 && p.Status==4 || p.Status==5) || p.Face) {
                        this.send.push({
                          Status: p.Status,
                          AttendanceId: p.AttendanceId,
                          AttendanceDtsId: p.AttendanceDtsId,
                          StudentId: p.StudentId,
                          ClassId: p.ClassId,
                          SectionId: p.SectionId,
                          IsLeave: p.IsLeave,
                          LeaveType: p.LeaveType,
                          LeaveId: p.LeaveId,
                          LeaveDtsId: p.LeaveDtsId,
                          IsMedical: p.IsMedical,
                          // Stop: true,
                        })
                      }
                      this.stData.push(p);
                    }
                  })
                })
                this.mainData.push(e);
              })
              console.log("mainData",this.mainData)
              //---------明细表-----------------------
              var tb = [];
              res.Data.forEach((e,index) => {
                tb.push({ ...e.Stat, Grade: e.Grade, })
              })
              this.mainTable = tb;
              //-------------------------------------
            }
          })
        } else {
          // this.$message.error(res.Msg);
        }
      })
    },
    statusChange(st,type) {
      st.show = false;
      // st.Status = type;
      if(st.Status >= 3) {
        st.Status = 1;
      } else {
        st.Status = st.Status + 1;
      }
      st.isChange = true;
      var obj = this.pickData.find(x => x.StudentId == st.StudentId);
      if(obj) {
        obj.Status = st.Status;
      } else {
        this.pickData.push(st);
      }
    },
    showStudents(row,grade) {
      this.dialogTitle = grade + " " + row.Class;
      this.dialogData = row.Students;
      this.dialogVisible = true;
    },
    // beforeSave() {
    //   var arr = [];
    //   this.mainData.forEach(e => {
    //     if(e.Grade=="高一") {
    //       arr.push(1);
    //     } else if(e.Grade=="高二") {
    //       arr.push(2);
    //     } else if(e.Grade=="高三") {
    //       arr.push(3);
    //     }
    //   })
    //   this.$refs.gradeDialog.open(arr);
    // },
    save(pick=[],dialogData=[]) {
      var isTime = false;
      var nowTime = (new Date(this.$commonJs.getNowDatetimeString())).getTime();
      if(this.TestTime) {
        nowTime = (new Date(this.TestTime)).getTime();
      }
      this.mainData.forEach(e => {
        var section = e.Section;
        var start = new Date(this.params.AttendanceDate + " " + section.RollCallStartTime);
        var end = new Date(this.params.AttendanceDate + " " + section.RollCallEndTime);
        if(start.getTime() <= nowTime && nowTime <= end.getTime()) {
          isTime = true;
          return;
        }
      })
      if(!isTime) {
        this.$message.error("现在不是手动考勤时间，不能提交");
        return;
      }
      var arr = [];
      this.pickData.forEach(p => {
        if(pick.length) {
          if(pick.indexOf(p.GradeSn) > -1) {
            arr.push({
              Status: p.Status,
              AttendanceId: p.AttendanceId,
              AttendanceDtsId: p.AttendanceDtsId,
              StudentId: p.StudentId,
              ClassId: p.ClassId,
              SectionId: p.SectionId,
              IsLeave: p.IsLeave,
              LeaveType: p.LeaveType,
              LeaveId: p.LeaveId,
              LeaveDtsId: p.LeaveDtsId,
              IsMedical: p.IsMedical,
              MedicalId: p.MedicalId,
            })
          }
        } else {
          var has = dialogData.find(x => x.StudentId==p.StudentId);
          if(has) {
            arr.push({
              Status: p.Status,
              AttendanceId: p.AttendanceId,
              AttendanceDtsId: p.AttendanceDtsId,
              StudentId: p.StudentId,
              ClassId: p.ClassId,
              SectionId: p.SectionId,
              IsLeave: p.IsLeave,
              LeaveType: p.LeaveType,
              LeaveId: p.LeaveId,
              LeaveDtsId: p.LeaveDtsId,
              IsMedical: p.IsMedical,
              MedicalId: p.MedicalId,
            })
          }
        }
      });
      // console.log("arr",arr)
      this.subData.Details = this.send.concat(arr);
      this.stData.forEach(e => {
        if(e.AttendanceDtsId == 0) {
          var obj = this.subData.Details.find(x => x.StudentId==e.StudentId);
          if(!obj) {
            this.subData.Details.push({
              Status: e.Status,
              AttendanceId: e.AttendanceId,
              AttendanceDtsId: e.AttendanceDtsId,
              StudentId: e.StudentId,
              ClassId: e.ClassId,
              SectionId: e.SectionId,
              IsLeave: e.IsLeave,
              LeaveType: e.LeaveType,
              LeaveId: e.LeaveId,
              LeaveDtsId: e.LeaveDtsId,
              IsMedical: e.IsMedical,
              MedicalId: e.MedicalId,
            })
          }
        }
      })
      this.subData.AttendanceDate = this.params.AttendanceDate;
      this.subData.SectionNumber = this.params.SectionNumber;
      // console.log(this.subData);
      // return;
      this.loading = true;
      this.api.stayRollCall(this.subData).then(res => {
        this.loading = false;
        if(res.Code==0) {
          this.$message.success("提交成功");
          this.dialogVisible = false;
          this.getData();
        } else {
          this.$message.error(res.Msg);
        }
      })
    },
    getGrade() {
      this.grade_api.list().then((res) => {
        this.grades = res.Data;
      });
    },
    getClass() {
      this.params.ClassId = null;
      if (!this.params.GradeId) {
        this.classes = [];
        return;
      }
      var params = { GradeId: this.params.GradeId, TermId: this.TermId };
      this.class_api.list(params).then((res) => {
        this.classes = res.Data;
      });
    },
    onExport() {
      this.bnLoading = true;
      this.api.exportStayStudents(this.queried).then(() => {
        this.bnLoading = false;
      }).catch(() => {
        this.bnLoading = false;
      })
    },
    hasGrade(sn) {
      var index = this.mainData.findIndex(x => x.GradeId == sn);
      return index > -1;
    },
    getWeek(get=false) {
      if(this.params.AttendanceDate) {
        var weekDay = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
        var myDate = new Date(Date.parse(this.params.AttendanceDate));
        this.day = weekDay[myDate.getDay()];
        if(get===true) {
          this.getData();
        }
      } else {
        this.day = "";
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.normal {
  color: #000;
  background-color: #000;
}

//异常
.absent {
  color: red;
  background-color: red;
}

// 迟到
.late {
  color: orange;
  background-color: orange;
}

//请假
.leave {
  color: #999;
}

//有记录正常
.checkNormal {
  color: #2a2;
  background-color: #2a2;
}
//刷脸
// .face {
//   color: #2f13de;
// }

//无故缺勤
.free {
  color: #950c0c;
  background-color: #950c0c;
}

// .freeBn {
//   background-color:#950c0c;
//   border-color:#950c0c;
//   &:hover {
//     background-color: rgba(149,12,12,0.7);
//     border-color: rgba(149,12,12,0.7);
//   }
// }

.statusText {
  font-size: 14px;
  margin-right: 5px;
  display: inline-block;
  font-weight: bold;
  @media screen and (max-width: 767px) {
    margin-right: 4px;
  }
}
.statusText.nobold {
  font-weight: normal;
}
.isNull {
  text-align: center;
  letter-spacing: 8px;
  font-size: 20px !important;
  color: #aaa;
  padding: 16% 5% 0 0 !important;
  @media screen and (max-width: 767px) {
    padding: 45% 0 0 0 !important;
  }
}

.border {
  margin: 15px 0;
  padding: 10px;
  font-size: 14px;
  width: 100%;
  height: calc(100vh - 220px);
  overflow: auto;
  @media screen and (max-width: 767px) {
    height: calc(100vh - 285px);
    margin: 5px 0 15px;
  }
  .mb-collage {
    /deep/ .el-collapse-item__content {
      padding-bottom: 6px !important;
    }
    .collage {
      display: flex;
      flex-wrap: wrap;
      .collage-item {
        width: 33.33%;
        margin-bottom: 4px;
        text-align: center;
      }
    }
  }
}

.footer {
  text-align: right;
  white-space: nowrap;
  @media screen and (min-width: 768px) {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  @media screen and (max-width: 365px) {
    margin-right: -4px;
  }
  .footer-tip {
    @media screen and (min-width: 768px) {
      line-height: 32px;
    }
    @media screen and (max-width: 767px) {
      width: fit-content;
      display: inline-block;
    }
  }
}

.checkinge-query {
  label {
    margin-right: 10px;
    font-weight: normal;
  }

  /deep/ .el-date-picker,
  .el-select,
  .el-input {
    width: 140px;
  }
  .query {
    display:inline-block;
    margin-right: 30px;
    @media screen and (max-width: 767px) {
      width: calc(50% - 5px);
      margin-right: 5px;
      .el-input,.el-select {
        width: calc(100% - 46px) !important;
      }
      label {
        display: inline-block;
        width: 36px;
        margin-bottom: 15px;
        text-align: center;
      }
    }
  }
}

.tab-group {
  .tab-item:first-child {
    border: none;
  }

  .tab-item {
    padding: 10px 5px;
    text-align: center;
    border: 1px solid #ddd;
    border-right: none;
    cursor: pointer;
  }

  .tab-item:last-child {
    border-right: 1px solid #ddd;
  }
}

.table {
  .table-item {
    display: flex;
    align-items: center;
    text-align: center;
    margin-bottom: 20px;
    .table-col {
      border-top: 1px solid #ddd;
      border-right: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }
    .table-col:last-child {
      border-right: 1px solid #ddd;
    }
    .table-high {
      min-width: 60px;
      border: none !important;
      span {
        display: inline-block;
        width: 14px;
      }
    }
    .grade-box {
      display:flex;
      flex-wrap:wrap;
      border-left:1px solid #ddd;
      .table-gradeList{
        width: 245px;
        // min-height: 220px;
        .table-gradeList_header {
          padding: 6px 0;
          background-color: #ddd;
          .table-gradeList_gradeNo{
            // width: 60px;
            width: fit-content;
            text-indent: 10px;
          }
        }
        .student-list{
          // height: 186px;
          overflow: auto;
          text-align: left;
          padding: 0 0 6px;
          .student-item{
            cursor: pointer;
            padding: 6px 0 0;
            display: inline-block;
            width: 80px;
            text-align: center;
            span {
              display: inline-block;
              width: 42px;
              text-align: left;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
  .table-item:last-child {
    margin-bottom: 0;
    .table-col {
      border-bottom: 1px solid #ddd;
    }
  }
}
.dialog-st {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0px;
  .dialog-st-item {
    width: 25%;
    text-align: center;
    margin-bottom: 15px;
    span {
      display: inline-block;
      width: 42px;
      text-align: left;
      white-space: nowrap;
      margin-left: 2px;
    }
  }
}
.isChange {
  color: #fff;
}
.test_box {
  position: absolute;
  z-index: 999;
  padding: 5px;
  top: 0;
  right: 0;
}
.test_box1 {
  width: 339px;
  background-color: #ffffff;
  border: 1px solid #959595;
}
.nobg {
  background: none;
}
.hand-icon {
  width: 16px;
  height: 16px;
  vertical-align: -3px;
  margin-right:2px;
}
.face-icon {
  width: 14px;
  height: 14px;
  vertical-align: -2px;
  margin-right:2px;
}
.bnBox {
  @media screen and (max-width: 767px) {
    margin-top: 5px;
  }
}
</style>